import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RestService } from '../../services/rest.service';

@Component({
  selector: 'app-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.css'],
})
export class VideoModalComponent implements OnInit {
  @Input() ytSrc: string;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  vLoading = true;
  vNotAv = false;
  constructor(private restService: RestService) {}

  ngOnInit() {
    // console.log([this.ytSrc]);
    this.vLoading = false;
    this.sendVideoAction();
  }

  cleanSRC() {
    this.ytSrc = 'NA';
    this.vLoading = true;
    this.vNotAv = false;
    this.closeModal.emit();
  }

  sendVideoAction() {
    let strAction = 'NA';
    if (this.restService.originConsulta === 1) {
      strAction = 'openVideoFromMAIL';
    } else {
      strAction = 'openVideoFromSMS';
    }
    const action =
      '{ "idLandingPage": 8, ' +
      '"idToken": -1,' +
      '"folioCotizacion": "' +
      this.restService.folio +
      '", ' +
      '"idAccionLandingPage": -1, ' +
      '"ip": "0.0.0.0", ' +
      '"navegador": "' +
      window.navigator.userAgent +
      '", ' +
      '"accion": "' +
      strAction +
      '", ' +
      '"validacionUsuario": false, ' +
      '"idOrigen": 17, ' +
      '"agente": -1 }';

    this.restService.sendAction(JSON.parse(action)).subscribe((result) => {
      // console.log('ACTION SENT');
      // console.log('RES: ' + JSON.stringify(result));
    });
  }
}
